// Action Creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Errors
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
import { Worker } from "@ms/planner-workers/lib/local/workers/Worker";
/**
 * Stops cache workers and deletes Planner's persisted IndexedDB data.
 */ export async function clearPlannerIndexedDB(workerLoader, persistentAsyncStorage) {
    workerLoader.load(Worker.CacheDataFetch).stop?.();
    workerLoader.load(Worker.CacheUpdate).stop?.();
    workerLoader.load(Worker.CacheEviction).stop?.();
    await persistentAsyncStorage.deleteAllStaleDatabases();
    await persistentAsyncStorage.deleteCurrentDatabase();
}
/**
 * Clears Planner's persisted IndexedDB data and reloads the app.
 * IndexedDB cleanup failures are logged so the reload can still proceed.
 */ export async function refreshPlannerApp(workerLoader, acLoader, persistentAsyncStorage, loggers, reloadApp) {
    if (persistentAsyncStorage !== null) {
        try {
            await clearPlannerIndexedDB(workerLoader, persistentAsyncStorage);
            await reloadApp();
        } catch (error) {
            const notificationActionCreator = acLoader.load(ActionCreator.Notification);
            loggers.traceLogger.logTrace(0x1d74e519 /* tag_33ouz */ , TraceLevel.Warning, `refreshPlannerApp - IndexedDB clear failed, continuing with reload [Error=${ErrorUtilities.getMessage(error)}]`);
            notificationActionCreator.showToast({
                title: Strings.Notifications_RemoteRefreshErrorTitle,
                body: {
                    content: Strings.Notifications_RemoteRefreshError
                },
                intent: "error",
                action: {
                    label: Strings.Notifications_RetryButtonText,
                    dismissOnAction: true,
                    onClick: ()=>{
                        void refreshPlannerApp(workerLoader, acLoader, persistentAsyncStorage, loggers, reloadApp);
                    }
                }
            });
        }
    }
}
